var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFraqvest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 35,
    viewBox: "0 0 153 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_707_720)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.896 27.6962V7.24432H53.2868V11.626H41.4315V15.2794H51.8673V19.6611H41.4315V27.6962H36.8931H36.896Z",
    fill: "#4B4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3428 27.6962V12.5029H58.5956V13.6147C59.5044 12.6516 60.8085 12.2116 62.5656 12.2116H64.0688V16.302H61.2615C59.3342 16.302 58.5956 17.4138 58.5956 20.101V27.6991H54.3428V27.6962Z",
    fill: "#4B4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3774 23.1391C64.3774 19.6611 66.2211 18.3472 70.5027 18.3472H74.5853C74.4151 16.7122 73.5063 16.0107 71.6366 16.0107C70.0209 16.0107 69.1409 16.5368 68.8582 17.7645H64.6602C65.0584 13.909 67.1848 12.2116 71.778 12.2116C76.7694 12.2116 78.867 14.2271 78.867 18.9328V27.6991H74.6142V26.5011C73.5351 27.5237 71.9771 27.9904 69.8507 27.9904C66.1086 27.9904 64.3774 26.5309 64.3774 23.1391ZM70.9557 24.1914C73.1687 24.1914 74.2449 23.4036 74.6142 21.7063V21.5606H71.6655C69.5391 21.5606 68.6302 22.0868 68.6302 22.9637C68.6302 23.8406 69.4814 24.1914 70.9557 24.1914Z",
    fill: "#4B4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.614 12.2116C88.7116 12.2116 90.2436 12.7378 91.2939 13.8763V12.5029H95.5467V35.0029H91.2939V26.3258C90.2436 27.4643 88.7145 27.9904 86.614 27.9904C82.1333 27.9904 80.2319 25.6242 80.2319 20.101C80.2319 14.5778 82.1333 12.2116 86.614 12.2116ZM91.2361 20.101C91.2361 17.4702 90.2148 16.302 87.8604 16.302C85.5061 16.302 84.4847 17.4702 84.4847 20.101C84.4847 22.7318 85.5061 23.9001 87.8604 23.9001C90.2148 23.9001 91.2361 22.7883 91.2361 20.101Z",
    fill: "#4B4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.928 12.5029L104.474 22.497L108.02 12.5029H112.558L106.886 27.6962H102.064L96.3921 12.5029H100.931H100.928Z",
    fill: "#4B4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.852 12.2116C125.212 12.2116 127.422 14.6076 127.422 20.101C127.422 20.5677 127.394 21.0374 127.365 21.5041H116.617C116.929 23.4036 118.092 24.1914 119.906 24.1914C121.069 24.1914 122.203 23.8703 122.8 22.7318H127.197C126.433 26.8519 123.597 27.9904 119.852 27.9904C114.491 27.9904 112.252 25.5945 112.252 20.101C112.252 14.6076 114.494 12.2116 119.852 12.2116ZM116.675 18.2877H123.141C122.717 16.5636 121.554 16.0077 119.906 16.0077C118.259 16.0077 117.099 16.5636 116.672 18.2877H116.675Z",
    fill: "#4B4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.342 22.7289C132.653 23.7515 133.617 24.1885 135.518 24.1885C137.22 24.1885 138.014 23.8377 138.014 23.3115C138.014 22.61 136.652 22.2295 134.638 21.9976C130.045 21.4715 128.285 20.0981 128.285 16.9709C128.285 13.6683 130.27 12.2087 134.751 12.2087C139.231 12.2087 141.586 13.8169 141.984 17.4673H137.786C137.446 16.4447 136.566 16.0077 134.667 16.0077C133.135 16.0077 132.399 16.299 132.399 16.7955C132.399 17.4673 133.732 17.7586 135.435 17.9935C140.455 18.695 142.128 19.8633 142.128 22.931C142.128 26.2901 140.114 27.9845 135.38 27.9845C130.645 27.9845 128.545 26.3763 128.146 22.7259H132.344L132.342 22.7289Z",
    fill: "#4B4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.714 12.5029V16.5933H148.885V21.736C148.885 23.0499 149.425 23.6058 150.787 23.6058H153V27.6962H150.674C146.447 27.6962 144.632 26.0612 144.632 22.2919V16.5933H142.647V12.5029H144.632V9.23004H148.885V12.5029H152.714Z",
    fill: "#4B4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.64753 6.849V20.764L0 27.613V13.692L6.64176 6.849H6.64753Z",
    fill: "#4B4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7257 0V6.84899H6.64746V6.84304L13.295 0H26.7257Z",
    fill: "#4B4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4468 18.0499V13.7753H13.2978V18.0499H17.4468Z",
    fill: "#4B4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0117 13.7753V20.6956H13.2949V27.613H26.7256V13.7753H20.0117Z",
    fill: "#4B4A4A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_707_720"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 153,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFraqvest);
export default __webpack_public_path__ + "static/media/fraqvest.6dbd2f7f2b5254d1854827399c0e6048.svg";
export { ForwardRef as ReactComponent };